
const PackHeadLen = 16;

class TransPacket {
    //static PackHeadLen = 16;

    constructor(versionInt, cmdInt, reserveInt, bodyUint8Af) {
        this.H_Version = 0;
        this.H_Cmd = 0;
        this.H_Reserve = 0;
        this.H_BodyLen = 0;
        this.PayloadBody = null; // Uint8Array

        if (Number(versionInt) > 0) {
            this.H_Version = versionInt;
        }
        if (Number(cmdInt) > 0) {
            this.H_Cmd = cmdInt;
        }
        if (Number(reserveInt) > 0) {
            this.H_Reserve = reserveInt;
        }

        if (bodyUint8Af) {
            this.H_BodyLen = bodyUint8Af.byteLength;
            this.PayloadBody = bodyUint8Af;
        }
    };

    encodeToBytes(){
        let buffer = new Uint8Array(PackHeadLen + this.H_BodyLen);
        let headBuffer = new ArrayBuffer(PackHeadLen);
        let dv = new DataView(headBuffer);
        dv.setUint32(0, this.H_Version);
        dv.setUint32(4, this.H_Cmd);
        dv.setUint32(8, this.H_BodyLen);
        dv.setUint32(12, this.H_Reserve);

        buffer.set(new Uint8Array(headBuffer), 0);
        if (this.H_BodyLen > 0){
            buffer.set(this.PayloadBody, headBuffer.byteLength);
        }
        
        return buffer.buffer;
    };

    static decodeByBytes(arrayBuffData){
        if (arrayBuffData.byteLength <= PackHeadLen){
            return null;
        }
        let dv = new DataView(arrayBuffData);
        let ver = dv.getUint32(0);
        let cmd = dv.getUint32(4);
        let bodyLen = dv.getUint32(8);
        let reserve = dv.getUint32(12);
        let bodyPayload = new Uint8Array(arrayBuffData.slice(PackHeadLen));
        return new TransPacket(ver, cmd, reserve, bodyPayload);
    };
}

// 导出对象
var MsgSvrPacker = {
    pack : function(verInt, cmdInt, dataUint8ArrBuf){
        let pack = new TransPacket(verInt, cmdInt, 0, dataUint8ArrBuf)
        return pack.encodeToBytes();
    },
    unpack : function(arrayBuffData){
        return TransPacket.decodeByBytes(arrayBuffData);
    },
}

// node exports
//module.exports.TransPacket = TransPacket;
// module.exports.MsgSvrPacker = MsgSvrPacker;
export default {
    MsgSvrPacker: MsgSvrPacker
}

// es6 exports


// WEBPACK FOOTER //
// ./src/vendor/qnbar/pack.js